<div style="display: grid; grid-template-columns: 150px 1fr; height: 100%">
    <mat-selection-list [multiple]="false" (selectionChange)="pageItemListChanged($event)" style="grid-column: 1;">
        <h1 matSubheader>Proposals</h1>
        <mat-list-option *ngFor="let pageItem of pageItems, let i = index" [value]="pageItem"
            [selected]="pageItem && i == 0">
            {{pageItem?.displayText ?? 'Null Value'}}
        </mat-list-option>
    </mat-selection-list>
    <ng-template #pageHost style="grid-column: 2;"></ng-template>
</div>